import React, { useState, useRef } from 'react';
import styled, { withTheme } from 'styled-components'
import useElementInertialParallax from '../../../hooks/useElementInertialParallax';
import { Wrapper } from '../../containers/Wrapper'

const Background = styled.div`
    width: 100%;
    padding: 150px 0;
    position: relative;
    z-index: 100;


    @media (min-width: ${props => props.theme.pageWidth.l}px) {
        padding: 200px 0;
        width: 100%
    }
`

const StyledWrapper = styled(Wrapper)`
    position: relative;
`;

const PaperContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    z-index: 1;
`

const PaperBackground = styled.img`
    height: 100%;

    @media (min-width: ${props => props.theme.pageWidth.l}px) {
        height: auto;
        width: 100%
    }
`;

const QuoteImage = styled.img`
    display: block;
    width: 110px;
    margin: 30px auto;

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        margin: 1rem auto;
    }
`

const Border = styled.div`
    position: relative;
    height: 1px;
    background:${props => `${props.theme.colors.primary}50`};
    width: 30%;
    display:flex;
    margin:0 auto;
    align-self: center;
    align-items: center;

    &::before, 
    &::after{
        position: absolute;
        content: " ";
        display:block;
        width:5px;
        height:5px;
        border-radius: 50%;
        background-color:${props => props.theme.colors.primary};
    }

    &::after{
        right:0;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        width:80%;
    }
`

const QuoteText = styled.h2`
    width:90%;
    margin: 0 auto;
    padding-top: 30px;
    text-align: center;
    font-size: 2.5em;
    font-family: ${props => props.theme.fonts.display};
    font-weight:400;
    color: ${props => props.theme.colors.primary};

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        font-size: 2em;
    }

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        font-size: 1.5em;
        padding-top: 1rem;
    }
`

const Quote = (props) => {
/*     const textParallaxElement = useRef(null)
    const backgroundParallaxElement = useRef(null)
    const [ backgroundOffset, setBackgroundOffset ] = useState(0)
    const [ textOffset, setTextOffset ] = useState(0) */

    let quoteImageSrc = props.quoteImageSrc
    let quoteBackground = require('../../../../assets/img/bg/' + props.quoteBg).default

/*     useElementInertialParallax((parallaxValue) => {
        setBackgroundOffset(5 + parallaxValue * -10)
        setTextOffset(-15 + parallaxValue * 30)
    }, backgroundParallaxElement) */

    return (
        <Background quoteBg={quoteBackground} /*ref={backgroundParallaxElement}  style={{transform: `translate3d(0,${backgroundOffset}%,0)`}} */>
            <PaperContainer>
                <PaperBackground src={quoteBackground}></PaperBackground>
            </PaperContainer>
            <StyledWrapper /* style={{transform: `translate3d(0,${textOffset}%,0)`}} */>
                <QuoteImage src={require(`../../../../assets/img/bg/${quoteImageSrc}`).default}></QuoteImage>
                <Border></Border>
                <QuoteText>{props.quoteContent}</QuoteText>
            </StyledWrapper>
        </Background>
    );
};

export default withTheme(Quote);